import {PropsType} from "./view.types";
import './view.styles.css';
import {ReactNode, useState} from "react";
import {PopUpContext} from "../context";

const PopUpHandler = ({children}: PropsType) => {
    const [showX, setShowX] = useState<boolean>(false)
    const [cancelable, setCancelable] = useState<boolean>(false)
    const [content, setContent] = useState<ReactNode | undefined>(undefined)
    const [onCancelCallback, setOnCancelCallback] = useState<(() => void) | undefined>(undefined)

    const showPopUp = (content: ReactNode, cancelable?: boolean, showX?: boolean, onCancel?: () => void) => {
        setShowX(showX || false)
        setCancelable(cancelable || false)
        setContent(content)
        setOnCancelCallback(() => onCancel)
    }

    const hidePopUp = () => {
        if (onCancelCallback) {
            onCancelCallback()
        }
        setContent(undefined)
    }

    return (
        <PopUpContext.Provider value={{showPopUp, hidePopUp}}>
            {
                content &&
                <div className="modalBG" onClick={(event) => {
                    if (cancelable) {
                        hidePopUp()
                    }
                }}>
                    <div className="modal" onClick={(event => {
                        event.stopPropagation()
                    })}>
                        {
                            cancelable && showX && <span className="close" onClick={(event) => {
                                event.stopPropagation();
                                hidePopUp()
                            }}>&times;</span>
                        }
                        <div className="modal_content">
                            {content}
                        </div>
                    </div>
                </div>
            }
            {children}
        </PopUpContext.Provider>
    )
}

export default PopUpHandler
